import React from 'react';
import {ButtonAddCustomer} from "../../Projects/components/ButtonAddCustomer/ButtonAddCustomer";

export function AddCustomerToProjectColumnFormatter(cellContent) {

  return <ButtonAddCustomer {...cellContent}/>
}